import { useState } from "react";

// Bump this whenever a crew photo is replaced under the same filename,
// so browsers holding an older copy are forced to fetch the new one.
const PHOTO_VERSION = "3";

export const CrewPhoto = ({ c, className = "aspect-[4/5]", pos = "object-[50%_30%]" }) => {
  const [failed, setFailed] = useState(false);
  const slug = c.name.split(" ")[0].toLowerCase();
  if (failed) {
    return (
      <span
        data-testid={`crew-photo-fallback-${slug}`}
        className={`grid place-items-center w-full ${className} rounded-xl border-[2.5px] border-[var(--ink)] font-display font-bold text-3xl text-white`}
        style={{ background: c.color }}
      >
        {c.name.charAt(0)}
      </span>
    );
  }
  return (
    <img
      data-testid={`crew-photo-${slug}`}
      src={`/images/crew/${slug}.jpg?v=${PHOTO_VERSION}`}
      alt={`${c.name}, ${c.role}`}
      onError={() => setFailed(true)}
      className={`w-full ${className} object-cover ${pos} rounded-xl border-[2.5px] border-[var(--ink)]`}
    />
  );
};
